import Box from '@amzn/awsui-components-react/polaris/box';
import Button from '@amzn/awsui-components-react/polaris/button';
import ColumnLayout from '@amzn/awsui-components-react/polaris/column-layout';
import Container from '@amzn/awsui-components-react/polaris/container';
import Header from '@amzn/awsui-components-react/polaris/header';
import { EventEngineEventsService } from '@amzn/event-engine-events-sdk';
import { ValueWithLabel } from '@amzn/event-engine-js-utils';
import React, { FC } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { i18nStrings } from 'utils/constants';
import getListValue from 'utils/get-list-value';

import { WORKSHOP_PATH } from '../constants';

export interface WorkshopInformationContainerProps {
    contentSummary: EventEngineEventsService.ParticipantContentSummary;
    isContentVisible?: boolean;
}

const WorkshopInformationContainer: FC<WorkshopInformationContainerProps> = ({
    contentSummary,
    isContentVisible,
}) => {
    const { url } = useRouteMatch();
    const history = useHistory();
    const workshopHref = `${url.replace(/\/$/, '')}/${WORKSHOP_PATH}`;

    return (
        <Container
            header={
                <Header
                    actions={
                        isContentVisible && (
                            <Button
                                iconName="angle-right"
                                iconAlign="right"
                                onFollow={(e) => {
                                    e.preventDefault();
                                    history.push(workshopHref);
                                }}
                                href={workshopHref}>
                                {i18nStrings.event.startWorkshop}
                            </Button>
                        )
                    }
                    variant="h2">
                    {i18nStrings.event.headers.workshop}
                </Header>
            }
            footer={
                <Box padding={{ vertical: 'xs' }}>
                    <ValueWithLabel
                        label={i18nStrings.event.labels.description}>
                        {contentSummary.description}
                    </ValueWithLabel>
                </Box>
            }>
            <ColumnLayout columns={4} variant="text-grid">
                <ValueWithLabel label={i18nStrings.event.labels.title}>
                    {contentSummary.title}
                </ValueWithLabel>
                <ValueWithLabel
                    label={i18nStrings.event.labels.complexityLevel}>
                    {contentSummary.complexityLevel}
                </ValueWithLabel>
                <ValueWithLabel label={i18nStrings.event.labels.AWSServices}>
                    {getListValue(contentSummary.awsServices)}
                </ValueWithLabel>
                <ValueWithLabel label={i18nStrings.event.labels.topics}>
                    {getListValue(contentSummary.topics)}
                </ValueWithLabel>
            </ColumnLayout>
        </Container>
    );
};

export default WorkshopInformationContainer;
